import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MopList } from './styled';
import { setModeClickHandler } from '../DefaultMopView/helpers';
import { Link } from '@chegg-ui/link';
import { useAppSelector } from '../../hooks/useAppSelector';
import { AppMode } from '../../redux/AppModeState/AppModeState.types';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { getString } from '../../constants/Strings';
import { doFireStatusUpdate, sendRioEventCallback } from '../../utils/CallbackUtils';
import { ElementType, PaymentMethodsCommandNames, sendRioEvent, SpecType, StatusTypes, SubType } from '@chegg/commerce-utils';
import MopListItem from '../MopListItem';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { paymentMethodsSelector, selectedMopSelector } from '../../redux/MopOnFileState/MopOnFileState.selectors';
import { resetForm } from '../../redux/PaymentState/helpers/resetForm';
import { getPaymentFieldLabelText } from '../PaymentForm/helpers';
import { PaymentFormDataFields } from '../UserAddress/constants';
import { saveConfigs } from '../../redux/ConfigState/ConfigState.actions';
var MopListView = function MopListView(props) {
  var hostedFieldsService = props.hostedFieldsService;
  var config = useAppSelector(configSelector);
  var selectedMop = useAppSelector(selectedMopSelector);
  var paymentMethods = useAppSelector(paymentMethodsSelector);
  var rioNamespace = config.rioNamespace,
    paymentForm = config.paymentForm;
  var dispatch = useDispatch();
  useEffect(function () {
    doFireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: PaymentMethodsCommandNames.MOP_SELECTED,
      payload: {
        data: selectedMop
      }
    }]);
  }, [selectedMop]);
  var addPaymentMethodClickHandler = function addPaymentMethodClickHandler(e) {
    e.preventDefault();

    //Rio logging: When user clicks on Add Payment Method CTA
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.ADD_PAYMENT_METHOD_CTA_CLICKED'),
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: sendRioEventCallback,
      namespace: rioNamespace
    });
    setModeClickHandler(AppMode.ADD, AppMode.LIST_MOPS, dispatch);
    dispatch(saveConfigs({
      isNewMopAddingToMopList: true
    }));
    resetForm(hostedFieldsService, dispatch);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MopList, {
    "data-test": DataTestAttributes.MOP_LIST
  }, paymentMethods.map(function (mop) {
    var cardId = mop.cardId;
    return /*#__PURE__*/React.createElement(MopListItem, {
      mop: mop,
      key: cardId,
      checked: selectedMop.cardId === cardId,
      hostedFieldsService: hostedFieldsService,
      rioNamespace: rioNamespace
    });
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    "data-test": DataTestAttributes.ADD_PAYMENT_METHOD_LINK,
    hasButtonBehavior: true,
    href: '#',
    onClick: addPaymentMethodClickHandler,
    role: 'button'
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.ADD_PAYMENT_METHOD) || getString('APP.MOPONFILE.ADD.PAYMENT.METHOD'))));
};
export default MopListView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/MopListView/index.js
// module id = 4570
// module chunks = 11